// UncertaintyCalculator.jsx
import React, { useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// Import calculator components
import Fluke5522ACalculator from "./Fluke5522ACalculator";
import Agilent3458ACalculator from "./Agilent3458ACalculator";
import Fluke5500ACalculator from "./Fluke5500ACalculator";

const drawerWidth = 240;
const fixedContentWidth = 500;

export default function UncertaintyCalculator() {
  const [activeCalculators, setActiveCalculators] = useState([]);

  const tabs = ["Fluke 5522A", "Agilent 3458A", "Fluke 5500A"];

  const getCalculatorComponent = (tab) => {
    switch (tab) {
      case "Fluke 5522A":
        return <Fluke5522ACalculator calibrator={tab} />;
      case "Agilent 3458A":
        return <Agilent3458ACalculator calibrator={tab} />;
      case "Fluke 5500A":
        return <Fluke5500ACalculator calibrator={tab} />;
      default:
        return null;
    }
  };

  const handleTabClick = (tab) => {
    setActiveCalculators((prev) =>
      prev.includes(tab) ? prev.filter((t) => t !== tab) : [...prev, tab]
    );
  };

  const handleCloseCalculator = (tab) => {
    setActiveCalculators((prev) => prev.filter((t) => t !== tab));
  };

  return (
    <Box sx={{ display: "flex", flexGrow: 1, overflow: "hidden" }}>
      {/* Sidebar Tabs (replaces List) */}
      <Box
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          borderRight: 1,
          borderColor: "divider",
          bgcolor: "#f9f9f9",
        }}
      >
        <Tabs
          orientation="vertical"
          variant="fullWidth"
          value={false} // prevents controlled selection; we'll handle via activeCalculators
          sx={{ borderRight: 1, borderColor: "divider", py: 2 }}
        >
          {tabs.map((tab) => (
            <Tab
              key={tab}
              label={tab}
              onClick={() => handleTabClick(tab)}
              sx={{
                borderRadius: 1,
                mx: 1,
                mb: 1,
                textTransform: "none",
                border: "1px solid",
                borderColor: "divider",
                backgroundColor: activeCalculators.includes(tab)
                  ? "primary.main"
                  : "transparent",
                color: activeCalculators.includes(tab)
                  ? "white"
                  : "text.primary",
                "&:hover": {
                  backgroundColor: activeCalculators.includes(tab)
                    ? "primary.dark"
                    : "action.hover",
                },
              }}
            />
          ))}
        </Tabs>
      </Box>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "background.default",
          p: 3,
          overflow: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2,
            py: 1,
            minHeight: 600,
            overflowX: activeCalculators.length > 3 ? "auto" : "hidden",
          }}
        >
          {activeCalculators.map((tab) => (
            <Box
              key={tab}
              sx={{
                width: fixedContentWidth,
                flexShrink: 0,
                position: "relative",
              }}
            >
              <IconButton
                size="small"
                sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
                onClick={() => handleCloseCalculator(tab)}
              >
                <CloseIcon />
              </IconButton>

              {getCalculatorComponent(tab)}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}